import { useSystemContext } from '../Context/SystemContext';
import Grid from './Grid';
import { Input } from './Input';
const yup = require('../interface/yup-br');

export const GridAnexos = ({ url, url_post = '', perms, canShow, CanEdit, canInsert, canDelete, disableModal = false, allowMultiFiles = false, ...rest }) => {
    const System = useSystemContext();
    // permissoes
    const _canShow = false;

    const _canInsert = perms ? System.methods.getUserRule(`alterar${perms}`) : typeof canInsert === 'boolean' ? canInsert : true;

    const _canDelete = perms ? System.methods.getUserRule(`deletar${perms}`) : typeof canDelete === 'boolean' ? canDelete : true;

    return (
        <Grid
            url={url}
            url_post={url_post}
            disableModal={disableModal}
            {...rest}
            canEdit={false}
            canInsert={_canInsert}
            canDelete={_canDelete}
            canShow={_canShow}
            showPDFExport={false}
            showCSVExport={false}
            GridHeaders={[
                {
                    title: 'Título',
                    field: 'titulo',
                    sort: true,
                    className: 'w-1/2 text-left pl-1',
                },
                {
                    title: 'Arquivo',
                    field: 'arquivo',
                    sort: true,
                    className: 'w-1/2 pl-1 text-left border-l border-gray-300',
                },
            ]}
            LineDataPrint={(item) => {
                return [item?.titulo, `#link=${item.arquivo}|view=${item.arquivo}`];
            }}
            validationSchema={() => {
                return yup.object().shape({
                    arquivo: yup.string(),
                });
            }}
            onRenderForm={(GridModes, setFieldValue, values) => {
                return (
                    <>
                        {!allowMultiFiles && (
                            <Input name="titulo" label="Título" className="w-92" />
                        )}
                        <div className={`mt-1 w-full pl-2 pr-2`}>
                            <label htmlFor="file_input" className="block">
                                {allowMultiFiles ? 'Selecione os arquivos para enviar' : 'Selecion o arquivo'}
                            </label>
                            <input
                                id="file_input"
                                type={allowMultiFiles ? 'file' : 'file'}
                                {...allowMultiFiles ? { multiple: true } : {}}
                                className={`block w-full rounded-md border px-1 py-2 `}
                                onChange={(e) => {
                                    if (allowMultiFiles) {
                                        setFieldValue('arquivos', e.target.files);
                                    } else {
                                        setFieldValue('arquivo', e.target.files[0]);
                                    }
                                }}
                            />
                        </div>
                    </>
                );
            }}
            onPrepareSaveRecord={(values) => {
                let newForm = new FormData();
                if (allowMultiFiles && values.arquivos instanceof FileList) {
                    for (let i = 0; i < values.arquivos.length; i++) {
                        newForm.append('arquivos', values.arquivos[i]);
                    }
                } else {
                    for (let key in values) {
                        newForm.append(key, values[key]);
                    }
                }
                return newForm;
            }}
        />
    );
};
